import { Outlet } from 'react-router-dom';

import image from '/authImg.svg';

import './index.css';

const AuthLayout = () => (
  <div className="flex w-full md:flex-col">
    <div className="flex w-1/2 md:w-lvw md:z-1">
      <div className="w-full object-cover">
        <img
          className="w-full min-h-[680px] object-cover md:w-full max-h-[100vh] md:h-96"
          src={image}
        />
      </div>
    </div>
    <div style={{ zIndex: '1000 !important' }} className="layoutAuth">
      <Outlet />
    </div>
  </div>
);

export default AuthLayout;
